// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__ds8iw","--error":"Tag_--error__rpHrI"};